import classNames from './DeleteStudentsPopup.module.scss';
import { TFunction } from 'i18next';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';

export interface StudentsTableData {
  name: string;
  teacher: string;
  classAndGrade: string;
}

export const convertStudentReportItemToStudentsTableData = (
  student: StudentReportItem,
  t: TFunction
) => {
  return {
    name: student.name,
    teacher: (student.teachers || []).map(t => `${t.firstName} ${t.lastName}`).join(', '),
    classAndGrade: `${student.groupName} | ${t(`grade_${student.gradeId}`)} ${t('grade')}`,
  } as StudentsTableData;
};

interface StudentsTableProps {
  students: StudentsTableData[];
}

const StudentsTable = ({ students }: StudentsTableProps) => {
  const { t } = useAdminTranslation();

  return (
    <div className={classNames.table}>
      <div className={classNames.tableHeader}>
        <div>{t('bulkActions.common.name')}</div>
        <div>{t('bulkActions.common.teacher')}</div>
        <div>{t('bulkActions.common.classAndGrade')}</div>
      </div>
      <div className={classNames.tableBody}>
        {(students || []).map((s, i) => (
          <div key={`StudentsTable-row--${i}`} className={classNames.tableRow}>
            <div>{s.name}</div>
            <div>{s.teacher}</div>
            <div>{s.classAndGrade}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentsTable;
